import {
  Box,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import theme from "../../../theme/theme";
import { capitalizeFirstLetter } from "../../../utils/strings";
import i18n from "../../../i18n-config";
import {
  CustomTableFooter,
  StyledTableCell,
  StyledTableRow,
} from "../../../components";
import { DeleteRoundedICON, EditRoundedICON } from "../../../assets/icons";
import { Utilisateur } from "../../../store/features/utilisateurSlice";
import { useState } from "react";

const style = {
  fontSize: 14,
  color: theme.colors.black,
};

interface Props {
  data: any;
  onEdit: (item: Utilisateur) => void;
  onDelete: (item: Utilisateur) => void;
}

function GestionUserTable({ data, onEdit, onDelete }: Props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event: any, newPage: any) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <TableContainer>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ bgcolor: "#fff" }}>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("utilisateurs"))}
            </TableCell>
            <TableCell sx={style}>
              {capitalizeFirstLetter(i18n.t("role"))}
            </TableCell>
            <TableCell sx={style}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(rowsPerPage > 0
              ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              : data
            ).map((item: any, index: any) => (
            <StyledTableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                cursor: "pointer",
              }}
            >
              <StyledTableCell>
                <Box>
                  <Typography fontSize={14} fontWeight="500">
                    {`${item.nom} ${item.prenom}`}
                  </Typography>
                  <Typography fontSize={12} color="#9BA69C" fontWeight={"400"}>
                    {item.email}
                  </Typography>
                </Box>
              </StyledTableCell>
              <StyledTableCell>
                {capitalizeFirstLetter(
                  String(item.roleUtilisateur).toLocaleLowerCase()
                )}
              </StyledTableCell>
              <StyledTableCell
                style={{ justifyContent: "flex-end", display: "flex" }}
              >
                <Stack direction={"row"} spacing={1}>
                  <IconButton onClick={() => onEdit(item)}>
                    <EditRoundedICON />
                  </IconButton>
                  <IconButton onClick={() => onDelete(item)}>
                    <DeleteRoundedICON />
                  </IconButton>
                </Stack>
              </StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
        <CustomTableFooter
          rowsPerPage={rowsPerPage}
          data={data}
          page={page}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Table>
    </TableContainer>
  );
}

export default GestionUserTable;
